import deepmerge from 'deepmerge'
import englishMessages from 'ra-language-english'

import en from './en.json'

export default deepmerge.all([englishMessages, en])
